// From https://github.com/enechain/protoc-acl/blob/32b7617e356fb07eb9a229b9a78f917d083d3cea/acl/acl.proto

// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file acl/v1/acl.proto (package acl.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file acl/v1/acl.proto.
 */
export const file_acl_v1_acl: GenFile = /*@__PURE__*/
  fileDesc("ChBhY2wvdjEvYWNsLnByb3RvEgZhY2wudjEiGgoKQWNsT3B0aW9ucxIMCgRyb2xlGAEgAygJOkgKBGFjbHMSHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxiDsgMgASgLMhIuYWNsLnYxLkFjbE9wdGlvbnNSBGFjbHNCcwoKY29tLmFjbC52MUIIQWNsUHJvdG9QAVoiZ2l0aHViLmNvbS9lbmVjaGFpbi9wcm90b2MtYWNsL2FjbKICA0FYWKoCBkFjbC5WMcoCBkFjbFxWMeICEkFjbFxWMVxHUEJNZXRhZGF0YeoCB0FjbDo6VjFiBnByb3RvMw", [file_google_protobuf_descriptor]);

/**
 * @generated from message acl.v1.AclOptions
 */
export type AclOptions = Message<"acl.v1.AclOptions"> & {
  /**
   * @generated from field: repeated string role = 1;
   */
  role: string[];
};

/**
 * Describes the message acl.v1.AclOptions.
 * Use `create(AclOptionsSchema)` to create a new message.
 */
export const AclOptionsSchema: GenMessage<AclOptions> = /*@__PURE__*/
  messageDesc(file_acl_v1_acl, 0);

/**
 * 50000 〜 100000がユーザーに開放されている番号
 *
 * @generated from extension: acl.v1.AclOptions acls = 55555;
 */
export const acls: GenExtension<MethodOptions, AclOptions> = /*@__PURE__*/
  extDesc(file_acl_v1_acl, 0);

